import { Component, Input } from '@angular/core';
import { MasterserviceService } from '../../../dataservices/master-service/masterservice.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { NewLanguageService } from './../../../dataservices/new-language/new-language.service';

@Component({
  selector: 'app-cme-desc',
  templateUrl: './cme-desc.component.html',
  styleUrls: ['./cme-desc.component.scss']
})
export class CmeDescComponent {

  @Input() data;

  constructor(private dss:DataStorageService, private masterSer: MasterserviceService,public mls:NewLanguageService) { }

  goBack(): void {
    const displayObj = {
      isShow: false,
      display_section: '',
      data: []
    };
    this.dss.suggAssList = [];
    this.dss.selected_suggAssList = [];

    this.masterSer.showWebModal.next(displayObj);
  }
}
